module.exports = __webpack_public_path__ + "static/media/zoom-out.bef023d7.svg";